<article
  class="bv-report-card"
  [class.bv-report-card--disabled]="disabled"
  [class.bv-report-card--premium]="requiresPremium"
>
  @if (requiresPremium) {
    <app-premium-badge class="bv-report-card__badge"></app-premium-badge>
  } @else if (requiresUpgrade) {
    <span bitBadge variant="primary" class="bv-report-card__badge">
      {{ "upgrade" | i18n }}
    </span>
  }

  <div class="bv-report-card__icon" [class.tw-grayscale]="disabled">
    @if (iconSrc) {
      <img [src]="iconSrc" alt="" class="bv-report-card__icon-image" aria-hidden="true" />
    } @else {
      <bit-svg [content]="icon" aria-hidden="true"></bit-svg>
    }
  </div>

  <h3 class="bv-report-card__title">{{ title }}</h3>
  <p class="bv-report-card__description">{{ description }}</p>

  @if (disabled) {
    <button
      type="button"
      bitButton
      buttonType="primary"
      class="bv-report-card__action"
      [disabled]="true"
    >
      {{ "viewReport" | i18n }}
    </button>
  } @else {
    <a bitButton buttonType="primary" class="bv-report-card__action" [routerLink]="route">
      {{ "viewReport" | i18n }}
    </a>
  }
</article>
